import Actions from './actions';
import { Dispatch } from 'redux';
import AuthenticatedController from '../controllers/AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import modalActions from '../modules/modalsState/actions';
import { ObjectUtils } from '@mm/utils';

export function showFacebookConnectModal(
  message: string,
  canBeHided = true,
  permissions: string,
) {
  return {
    type: Actions.SHOW_FACEBOOK_CONNECT_MODAL,
    payload: {
      message,
      canBeHided,
      permissions,
    },
  };
}

export function hideFacebookConnectModal() {
  return {
    type: Actions.HIDE_FACEBOOK_CONNECT_MODAL,
  };
}

export function hideAllModals() {
  return (dispatch: Dispatch<StoreState>) => {
    dispatch(hideFacebookConnectModal());
    dispatch(modalActions.closeModal());
  };
}

export function getEnv() {
  return async (dispatch: Dispatch<StoreState>) => {
    try {
      const response = await AuthenticatedController.get(APIRoutes.ENV);
      const widgetsByPlatforms = ObjectUtils.mapObjKeysToSnakeCase(
        response.widgetsByPlatforms,
      );

      widgetsByPlatforms.sms_optin_v2 = widgetsByPlatforms.sms_optin_v_2;
      delete widgetsByPlatforms.sms_optin_v_2;

      dispatch({
        type: Actions.SET_ENV,
        payload: {
          fbAppId: response.fbAppId,
          fbPageId: response.fbPageId,
          gaTrackingId: response.gaTrackingId,
          botWidget: response.botWidget,
          recurlySubdomain: response.recurlySubdomain,
          globalJavascriptBaseUrl: response.globalJavascriptBaseUrl,
          notificationBanners: response.notificationBanners || [],
          sysVariablesAllowedToAssign:
            response.sysVariablesAllowedToAssign || {},
          userCountry: response.userCountry,
          webchatHost: response.webchatHost,
          daysForIndefinitelyAway: response.daysForIndefinitelyAway,
          creditsQuantity: response.creditsQuantity,
          widgetsByPlatforms,
          uncompliantDomainsList: response.uncompliantDomainsList || [],
        },
      });
      return response;
    } catch (error) {
      commonHandler(dispatch)(error);
    }
  };
}

export function showWidgetErrorModal(message: string) {
  return {
    type: Actions.SHOW_WIDGET_ERROR_MODAL,
    payload: {
      message,
    },
  };
}

export function hideWidgetErrorModal() {
  return {
    type: Actions.HIDE_WIDGET_ERROR_MODAL,
  };
}
